import { render, staticRenderFns } from "./OperateModal.vue?vue&type=template&id=060ef82a&"
import script from "./OperateModal.vue?vue&type=script&lang=js&"
export * from "./OperateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports